'use client';

import { useEffect, useSyncExternalStore } from 'react';
import {
  applyDocumentLocale,
  getLocaleSnapshot,
  getServerLocaleSnapshot,
  subscribeLocale,
  type Locale,
} from './locale';

/**
 * The language selected in Settings.
 *
 * The store lives outside React (localStorage plus two window events), so it is
 * read through `useSyncExternalStore`: the server snapshot is the default, and
 * the client adopts the persisted value as part of hydration.
 *
 * The effect re-applies `<html lang>` on every mount, not only when the user
 * changes languages. The server cannot know the stored language, so every
 * refresh arrives with the default in the markup and would otherwise keep it.
 */
export function useLocale(): Locale {
  const locale = useSyncExternalStore(
    subscribeLocale,
    getLocaleSnapshot,
    getServerLocaleSnapshot,
  );

  useEffect(() => {
    applyDocumentLocale(locale);
  }, [locale]);

  return locale;
}
